<template>
  <div class="Stage3Content ">
    <video class="video2" autoplay loop muted playsinline>
      <source  :src="video_src10" type="video/mp4" key="2">
    </video>
    <div class="bg_filter"></div>
    <div class="lightbox" v-if="isLightbox" >
        <transition appear name="pageTitle">
            <img :src="imgLightbox" alt="img" @click="isLightbox = !isLightbox">
        </transition>
        <transition appear name="pageTitle">
            <button @click="isLightbox = !isLightbox">Close</button>
        </transition>
    </div>
     <div id="top"></div>
     <transition appear name="pageTitle">
        <div class="content-header">
            <h1>STAGE3</h1>
        </div>
     </transition>
      <div class="grid-wrapper">
          <div class="item item1  item-card item-awards-title-block">
            <h1>  </h1>
            <p></p>
            <transition appear name="pageTitle">
                <div class="awards-list">
                    <p>FESTIVAL TOWER WEST</p>
                    <p>STAGE3</p>
                    <p>Mar.12-Apr.07</p>
                    <p>大阪</p>
                    <p>中之島</p>
                </div>
            </transition>
          </div>
          <div class="item item2  item-flex-center">
            <img :src="imgTitle3" alt="" class="stage-imges-top">
          </div>
          <div class="item item3 item-card item-flex-center">
            <div class="awards-title">
                <h1>BUILDING </h1>
                <p>Photos related to the BUILDING</p>
            </div>
          </div>
          <div class="item item4" v-on:click="lightbox(imgstage3_1)" :style="{'background-image': 'url(' + imgstage3_1 + ')' , 'background-size':'cover', 'background-position':'center'}"></div>
          <div class="item item4" v-on:click="lightbox(imgstage3_2)" :style="{'background-image': 'url(' + imgstage3_2 + ')' , 'background-size':'cover', 'background-position':'center'}"></div>
          <div class="item item4" v-on:click="lightbox(imgstage3_3)" :style="{'background-image': 'url(' + imgstage3_3 + ')' , 'background-size':'cover', 'background-position':'center'}"></div>
           <div class="item item3 item-card item-flex-center">
            <div class="awards-title">
                <h1>BOAT </h1>
                <p>Photos related to the BOAT</p>
            </div>
          </div>
           <div class="item item4" v-on:click="lightbox(imgstage3_6)" :style="{'background-image': 'url(' + imgstage3_4 + ')' , 'background-size':'cover', 'background-position':'center'}"></div>
          
          
           <div class="item item3 item-card item-flex-center">
            <div class="awards-title">
                <h1>STAR WARS </h1>
                <p>Photos related to the STAR WARS</p>
            </div>
          </div>
           <div class="item item5" v-on:click="lightbox(imgstage3_5)" :style="{'background-image': 'url(' + imgstage3_5 + ')' , 'background-size':'cover', 'background-position':'center'}"></div>
           <div class="item item4" v-on:click="lightbox(imgstage3_6)" :style="{'background-image': 'url(' + imgstage3_6 + ')' , 'background-size':'cover', 'background-position':'top'}"></div>
           <div class="item item4" v-on:click="lightbox(imgstage3_7)" :style="{'background-image': 'url(' + imgstage3_7 + ')' , 'background-size':'cover', 'background-position':'center'}"></div>
           <div class="item item4" v-on:click="lightbox(imgstage3_8)" :style="{'background-image': 'url(' + imgstage3_8 + ')' , 'background-size':'cover', 'background-position':'center'}"></div>
           <div class="item item4" v-on:click="lightbox(imgstage3_9)" :style="{'background-image': 'url(' + imgstage3_9 + ')' , 'background-size':'cover', 'background-position':'bottom right'}"></div>
           <div class="item item5" v-on:click="lightbox(imgstage3_10)" :style="{'background-image': 'url(' + imgstage3_10 + ')' , 'background-size':'cover', 'background-position':'bottom'}"></div>
           <div class="item item4" v-on:click="lightbox(imgstage3_11)" :style="{'background-image': 'url(' + imgstage3_11 + ')' , 'background-size':'cover', 'background-position':'center'}"></div>
           <div class="item item4" v-on:click="lightbox(imgstage3_12)" :style="{'background-image': 'url(' + imgstage3_12 + ')' , 'background-size':'cover', 'background-position':'center'}"></div>
      
    </div>
    <div class="content-footer">
        <div class="footer-menu">
          <router-link to="/">
          <h3>HOME</h3>
          <p>2018 TOURdeHDR+ COLLECTION</p>
          <p>STAGE 1 - 11</p>
          </router-link>
        </div>
        <div class="footer-menu">
          <router-link to="/project">
          <h3>STAGE</h3>
          <p>It is the main picture of the stage</p>
           </router-link>
        </div>
        <div class="footer-menu">
           <router-link to="/awards">
          <h3>AWARDS</h3>
          <p>I picked up a good picture of the year</p>
          </router-link>
        </div>
      </div>
      <div class="nav-footer">
          <div class="nav-item">
              <div class="nav-prev">
                  <router-link to="/stage2">
                    <i class="fas fa-angle-left fa-1x"></i><span>Prev</span>
                   </router-link>
              </div>

              <div>
                  <span>STAGE</span>
              </div>
                
              <div class="nav-next">
                <router-link to="/stage4">
                    <span>Next</span><i class="fas fa-angle-right fa-1x"></i>
                </router-link>
              </div>
           </div>
      </div>
      <div class="sns-footer">
        <a href="https://twitter.com/TOURdeHDR" target="_blank">
          <div class="sns-item"><i class="fab fa-3x fa-twitter-square"></i></div>
        </a>
        <a href="https://www.instagram.com/yoshiak_hiramatsu_hdr/?hl=ja" target="_blank">
          <div class="sns-item"><i class="fab fa-3x fa-instagram"></i></div>
        </a>
        <a href="http://tourdehdr.sakuratan.com/site2/" target="_blank">
          <div class="sns-item">
             <svg version="1.1" id="レイヤー_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                y="0px" viewBox="0 0 1280 1024" style="enable-background:new 0 0 1280 1024;" xml:space="preserve">

                <g>
                  <path class="st0" d="M447,779c-16,0-29-13-29-29V312c0-16,13-29,29-29h438c16,0,29,13,29,29v438c0,16-13,29-29,29H447z"/>
                  <path d="M885,285c14.9,0,27,12.1,27,27v438c0,14.9-12.1,27-27,27H447c-14.9,0-27-12.1-27-27V312c0-14.9,12.1-27,27-27H885 M885,281
                    H447c-17.1,0-31,13.9-31,31v438c0,17.1,13.9,31,31,31h438c17.1,0,31-13.9,31-31V312C916,294.9,902.1,281,885,281L885,281z"/>
                </g>
                <g>
                  <path d="M570.1,312.4v237.2h-61.7V450H490v99.6h-61.7V312.4H490v84.8h18.5v-84.8H570.1z"/>
                </g>
                <g>
                  <path class="st1" d="M595.4,378.5h46.1c29.8,0,49.9,1.4,60.4,4.1c10.5,2.7,18.5,7.2,24,13.5c5.5,6.3,8.9,13.2,10.3,20.9
                    c1.4,7.7,2.1,22.7,2.1,45.2v83.1c0,21.3-1,35.5-3,42.7c-2,7.2-5.5,12.8-10.5,16.8c-5,4.1-11.1,6.9-18.5,8.5s-18.4,2.4-33.1,2.4
                    h-77.8V378.5z M657.1,419.1v156c8.9,0,14.4-1.8,16.4-5.3c2.1-3.6,3.1-13.3,3.1-29.1v-92.1c0-10.7-0.3-17.6-1-20.7
                    c-0.7-3-2.2-5.2-4.7-6.7C668.4,419.8,663.8,419.1,657.1,419.1z"/>
                </g>
                <g>
                  <path class="st2" d="M766.7,444.7h43.7c29.1,0,48.8,1.1,59.1,3.4c10.3,2.2,18.7,8,25.2,17.2c6.5,9.2,9.7,24,9.7,44.2
                    c0,18.5-2.3,30.9-6.9,37.2c-4.6,6.3-13.6,10.2-27.1,11.4c12.2,3,20.4,7.1,24.6,12.2c4.2,5.1,6.8,9.7,7.8,14s1.5,15.9,1.5,35.1v62.5
                    h-57.3V603c0-12.7-1-20.6-3-23.6c-2-3-7.3-4.5-15.7-4.5v106.9h-61.7V444.7z M828.4,485.2V538c6.9,0,11.8-1,14.6-2.9
                    s4.2-8.1,4.2-18.5v-13c0-7.5-1.3-12.5-4-14.8C840.4,486.4,835.5,485.2,828.4,485.2z"/>
                </g>
                <g>
                  <rect x="342" y="1159" width="583" height="129"/>
                </g>
                <g>
                  <path d="M416,690v60c0,17.1,13.9,31,31,31h438c17.1,0,31-13.9,31-31v-60H416z"/>
                </g>
              </svg>
          </div>
        </a>
      </div>
      <div class="sns-footer">
          <div class="sns-item"><i class="fas fa-copyright">TOURdeHDR</i></div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'stage3Content',
  props: {
    msg: String
  },
  data() {
    return {
        isLightbox: false,
        imgLightbox: null,
    //   video_src1: require("../assets/img/Indian Tea.mp4"),
    //   video_src2: require("../assets/img/Painting960.mp4"), 
    //   video_src3: require("../assets/img/Night-Traffic.mp4"),
    //   video_src4: require("../assets/img/Autumn18420.mp4"),
    //   video_src5: require("../assets/img/Beach7262.mp4"),
    //   video_src6: require("../assets/img/Beach4722.mp4"),
    //   video_src7: require("../assets/img/BK-club.mp4"),
    //   video_src8: require("../assets/img/Broadway.mp4"),
    //   video_src9: require("../assets/img/Clouds17723.mp4"),
      video_src10: require("../assets/img/ComputerKeyboard3174.mp4"),
    //   video_src11: require("../assets/img/HappyNewYear3565.mp4"),
    //   video_src12: require("../assets/img/Reading 608.mp4"),
    //   video_src13: require("../assets/img/Restaurant1192.mp4"),
    //   video_src14: require("../assets/img/Sea4006.mp4"),
    //   video_src15: require("../assets/img/Train2213.mp4"),
    //   video_src16: require("../assets/img/MercedesGlk1406.mp4"),
    //   video_src17: require("../assets/img/Night-vision.mp4"),
    //   video_src18: require("../assets/img/Island2946.mp4"),
    //   video_src19: require("../assets/img/Plant5635.mp4"),
    //   video_src20: require("../assets/img/Pinwheel11051.mp4"),
      isTitle: true,

    //   img1: require("../assets/img/hdr/awards2018mozaiku_white.jpg"),
    //   img2: require("../assets/img/hdr/awards2017red2.jpg"),

    //   imgTitle1: require("../assets/img/hdr/universal960x640.jpg"),
    //   imgTitle2: require("../assets/img/hdr/gion_title1.jpg"),
      imgTitle3: require("../assets/img/hdr/festival_title2.jpg"),
    //   imgTitle4: require("../assets/img/hdr/hinase_title3.jpg"),
    //   imgTitle5: require("../assets/img/hdr/img7718_titleMini.jpg"),
    //   imgTitle6: require("../assets/img/hdr/akouganngu_title7.jpg"),
    //   imgTitle7: require("../assets/img/hdr/img9697_title6.jpg"),
    //   imgTitle8: require("../assets/img/hdr/img4122_title1.jpg"),
    //   imgTitle9: require("../assets/img/hdr/fukuyamajyou_title11.jpg"),
    //   imgTitle10: require("../assets/img/hdr/sc2_title1.jpg"),
    //   imgTitle11: require("../assets/img/hdr/BrightChristmas.jpg"),
      

      imgstage3_1: require("../assets/img/hdr/img5639.jpg"),
      imgstage3_2: require("../assets/img/hdr/img5816.jpg"),
      imgstage3_3: require("../assets/img/hdr/5543comp1.jpg"),

      imgstage3_4: require("../assets/img/hdr/img5777.jpg"),

      imgstage3_5: require("../assets/img/hdr/img5525_comp.jpg"),
      imgstage3_6: require("../assets/img/hdr/imag5549_comp_starwars2.jpg"),
      imgstage3_7: require("../assets/img/hdr/5543comp1_starwars1.jpg"),
      imgstage3_8: require("../assets/img/hdr/img5594_comp.jpg"),
      imgstage3_9: require("../assets/img/hdr/img5642_comp.jpg"),
      imgstage3_10: require("../assets/img/hdr/img5711_comp3.jpg"),
      imgstage3_11: require("../assets/img/hdr/img5582.jpg"),
      imgstage3_12: require("../assets/img/hdr/img5678_comp1.jpg"),
      imgstage3_13: require("../assets/img/hdr/img5777_comp.jpg"),

    }
  },
  // created() {
  // },
  // mounted: function(){

      // window.addEventListener("DOMContentLoaded", this.handleLoad);
        // this.loading = true;
        // this.getUnits()
  // },
  methods: {
    lightbox: function(img){
          this.isLightbox = true;
          this.imgLightbox = img;
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/scss/page/stage.scss";
</style>
